export default __webpack_public_path__ + "static/media/lang_en.9d602c3c.svg";